import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

/**
 * Periodically checks whether the server session is still alive.
 * Catches the case where the user is idle on a page with no active
 * API calls — the fetch interceptor only fires on API calls.
 *
 * Checks every 2 minutes. Redirects to /sign-in if the server says
 * the session is no longer valid.
 */
const CHECK_INTERVAL_MS = 2 * 60 * 1000; // 2 minutes

export function useSessionWatcher() {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) return;

    const interval = setInterval(() => {
      fetch('/api/auth/status')
        .then((res) => {
          if (!res.ok) {
            // Session expired — let the browser follow the redirect naturally.
            window.location.href = '/sign-in';
          }
        })
        .catch(() => {
          // Network error, CORS, server down — silently ignore.
          // The user will notice the app is broken and can refresh manually.
        });
    }, CHECK_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [isAuthenticated]);
}
